import { Button, Grid, MenuItem, Stack } from "@mui/material";
import CustomModal from "components/CustomModal";
import Field from "components/Field";
import { required } from "components/Field/validate";
import { Formik } from "formik";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { inviteOwnerHandler } from "store/actions/admin/clients";

const InviteClient = ({
  title = "Ajouter un client",
  showModal = false,
  toggleInviteClientModal,
  clientDetails = null,
}) => {
  const dispatch = useDispatch();
  const closeModalHandler = () => {
    toggleInviteClientModal();
  };
  const [showDeleteModel, setDeleteModel] = useState(false);
  const toggleDeleteModel = () => {
    setDeleteModel(!showDeleteModel);
  };
  return (
    <>
      <CustomModal
        open={showModal}
        onCloseHandler={closeModalHandler}
        modalWidth="636px"
        title={title}
      >
        <Formik
          enableReinitialize={true}
          initialValues={{
            email: clientDetails?.email || "",
            subscription_id:
              clientDetails?.organization?.subscription?._id ||
              "sub_2pHUOgQCvu47",
            start_date: clientDetails?.organization?.subscription?.start_date
              ? new Date(clientDetails.organization.subscription.start_date).toISOString().split('T')[0]
              : new Date().toISOString().split('T')[0],
            end_date:
              clientDetails?.organization?.subscription?.end_date
                ? new Date(clientDetails.organization.subscription.end_date).toISOString().split('T')[0]
                : (() => {
                  const tomorrow = new Date();
                  tomorrow.setDate(tomorrow.getDate() + 1);
                  return tomorrow.toISOString().split('T')[0];
                })(),
          }}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            dispatch(inviteOwnerHandler(values, toggleInviteClientModal));
          }}
        >
          {(props) => {
            const { handleSubmit, isSubmitting, values } = props;
            return (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={12}>
                    <Field
                      type="text"
                      label="Adresse e-mail *"
                      placeholder="Adresse e-mail *"
                      name="email"
                      validate={required}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <Field
                      type="select"
                      label="Subscription *"
                      placeholder="Subscription"
                      name="subscription_id"
                      notched={true}
                    >
                      <MenuItem selected value="sub_2pHUOgQCvu47">
                        Evo Basic
                      </MenuItem>
                      <MenuItem value="sub_6kDDeeJljwpj">Evo Pro</MenuItem>
                      <MenuItem value="sub_szUqLMi2XFYq">Evo Master</MenuItem>
                    </Field>
                  </Grid>
                  <Grid item sm={6}>
                    <Field
                      type="date"
                      label="Start Date *"
                      placeholder="Start Date *"
                      name="start_date"
                      notched={true}
                      validate={required}
                      minDate={clientDetails?._id ? null : new Date()}
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <Field
                      type="date"
                      label="End Date *"
                      placeholder="End Date *"
                      notched={true}
                      name="end_date"
                      validate={required}
                      minDate={values?.start_date}
                    />
                  </Grid>
                </Grid>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  alignItems="center"
                  justifyContent="space-between"
                  gap={2}
                  mt={2}
                >
                  <Button
                    sx={{ width: "100%" }}
                    color="secondary"
                    variant="outlined"
                    onClick={() => closeModalHandler()}
                  >
                    Fermer
                  </Button>
                  <Button
                    sx={{ width: "100%" }}
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting || !props.isValid}
                  >
                    {clientDetails?._id ? "Sauvegarder" : "Ajouter"}
                  </Button>
                </Stack>
              </form>
            );
          }}
        </Formik>
      </CustomModal>
    </>
  );
};

export default InviteClient;
